import type { HsSubscriberFunction } from '../types/subscriber-function.type';

export class HsObservable<T> {
  protected subscribers: Set<HsSubscriberFunction<T>> = new Set<HsSubscriberFunction<T>>();

  protected setSubscribers(subscribers: Set<HsSubscriberFunction<T>>): void {
    this.subscribers = subscribers;
  }

  public subscribe(subscriber: HsSubscriberFunction<T>): [HsObservable<T>, HsSubscriberFunction<T>] {
    this.subscribers.add(subscriber);
    return [this, subscriber];
  }

  public unsubscribe(subscriber: HsSubscriberFunction<T>): void {
    this.subscribers.delete(subscriber);
  }
}
